import { useEffect } from "react";

const setMeta = (name, content, attr = "name") => {
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, name); document.head.appendChild(el); }
  el.setAttribute("content", content);
};

export default function useSeo(title, description) {
  useEffect(() => {
    const full = `${title} | Vivaah Royale`;
    document.title = full;
    setMeta("og:title", full, "property");
    if (description) { setMeta("description", description); setMeta("og:description", description, "property"); }
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) { link = document.createElement("link"); link.rel = "canonical"; document.head.appendChild(link); }
    link.href = window.location.origin + window.location.pathname;
  }, [title, description]);
}
